/**
 * Read an auth value for THIS tab: sessionStorage first, then localStorage.
 *
 * sessionStorage is per-tab, localStorage is shared by every tab on the origin. An admin
 * "login as user" tab keeps the impersonated user's token/personId in sessionStorage only,
 * while localStorage still holds the admin's — so session must win. `!== null` (not `||`)
 * so an empty value in this tab never falls through to another tab's login.
 */
export const getAuthItem = (key) => {
  const value = sessionStorage.getItem(key);
  return value !== null ? value : localStorage.getItem(key);
};
